import { c as _c } from "react/compiler-runtime";
import type { VipInMessage } from '@module/types/centrifuge/public-message/inMessageTypes';
interface Props {
  item: VipInMessage;
}
export default function VIPFanInChat(props) {
  const $ = _c(2);
  const {
    item
  } = props;
  const {
    message
  } = item.data;
  const t0 = `${message.nick} 님께서 입장하셨습니다.`;
  let t1;
  if ($[0] !== t0) {
    t1 = <div className="mb-[3px] whitespace-pre-wrap text-cht_entr_mz"><div>{t0}</div></div>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}